import { ReactElement } from "react";
import { HubItemCategoryModel } from "client/Api/Hub/hub";
import { EventPreviewModel } from "client/Api/Hub/Events/eventViewer";
import { ActiveFilter } from "client/Features/Hub/common";
import { HubCardItem } from "./HubCardItem";
import { HubListItem } from "./HubListItem";
import { TimeZone } from "client/DateAndTime/timezones";

export type HubItemProps = {
	onNavigate(): void;
	onActiveFilterChange(filter: ActiveFilter): void;
	onSelectedCategoryIdChange(selectedCategoryId: number | null): void;
	getCategory: (categoryId: number | null) => HubItemCategoryModel | undefined;
	item: EventPreviewModel;
	isMobile: boolean;
	trackingId: string;
	timezone: TimeZone;
};

export const HubItem = (props: HubItemProps): ReactElement => {
	const {
		onNavigate,
		onActiveFilterChange,
		onSelectedCategoryIdChange,
		getCategory,
		item,
		isMobile,
		trackingId,
		timezone
	} = props;

	const {
		title,
		category,
		author,
		location,
		startDate,
		endDate,
		attendeeCount,
		media,
		locationType,
		isNew,
		areCommentsEnabled,
		commentsCount,
		reactionCounters
	} = item;

	return isMobile
		? (
			<HubListItem
				title={title}
				category={getCategory(category?.id ?? null)}
				author={author}
				location={location}
				startDate={startDate}
				attendeeCount={attendeeCount}
				media={media}
				onNavigate={onNavigate}
				trackingId={trackingId}
				timezone={timezone}
				isNew={isNew}
				areCommentsEnabled={areCommentsEnabled}
				numberOfComments={commentsCount}
				reactionCounters={reactionCounters}
			/>
		)
		: (
			<HubCardItem
				title={title}
				category={getCategory(category?.id ?? null)}
				author={author}
				location={location}
				startDate={startDate}
				endDate={endDate}
				attendeeCount={attendeeCount}
				media={media}
				onNavigate={onNavigate}
				onActiveFilterChange={onActiveFilterChange}
				onSelectedCategoryIdChange={onSelectedCategoryIdChange}
				trackingId={trackingId}
				timezone={timezone}
				locationType={locationType}
				isNew={isNew}
				numberOfComments={commentsCount}
				reactionCounters={reactionCounters}
				areCommentsEnabled={areCommentsEnabled}
			/>
		);
};

HubItem.displayName = "HubItem";